export default function Components() {
  return <h1>base widgets</h1>;
}
